/* ==============================================================================================
 * ASSOCIATED ISSUER MODAL
 * ============================================================================================== */

var Sushi;
var CGS;

(function (Sushi, Plugins, CGS) {
	"use strict";

	var BasePlugin = Plugins.BasePlugin;
	var OffCanvas = Plugins.OffCanvas;
	var Events = Sushi.Events;

	var AssociatedIssuer = function (triggerElement, options) {
		if (Sushi.getPluginInstance("AssociatedIssuer", triggerElement)) {
			return;
		}

		this.element = triggerElement;
		this.parentRow = this.element.closest("tr");

		BasePlugin.call(this, this.element, options);

		this.element.setAttribute("href", "#");
		this.element.setAttribute("data-off-canvas-content", "#associatedIssuerModal");
		this.element.setAttribute("data-off-canvas-position", "top right");
		this.element.setAttribute("data-off-canvas-from", "right");
		this.element.setAttribute("data-off-canvas-lock-scroll", "true");
		this.element.setAttribute("data-off-canvas-modifiers", "offCanvas large");
		this.element.setAttribute("data-off-canvas-opens-from-hash", "false");
		this.element.setAttribute("data-off-canvas-close-on-overlay-click", "true");

		this.modal = new OffCanvas(this.element);

		Events(this.modal.element).on("Modal.open", this.handleModalOpen.bind(this));
		Events(this.modal.element).on("Modal.close", this.handleModalClose.bind(this));
	};

	AssociatedIssuer.displayName = "AssociatedIssuer";

	AssociatedIssuer.prototype = Object.create(BasePlugin.prototype);

	var proto = AssociatedIssuer.prototype;

	proto.constructor = AssociatedIssuer;

    proto.handleModalClose = function () {
		if (this.parentRow) {
			this.parentRow.classList.remove("c-table__row--active");
		}
	};

	proto.handleModalOpen = function () {
		if (this.parentRow) {
			this.parentRow.classList.add("c-table__row--active");
		}

		// TODO: Update api endpoint URL
		var apiEndpoint = "/json/access/issuerAssociatedIssuer.json";

		var tableElement = this.modal.element.querySelector("table");

		var columns = [
			{
				"data": "issuerNumber",
				"className": "c-table__cell",
				"searchable": true,
			},
			{
				"data": "issuerName",
				"className": "c-table__cell",
				"searchable": true,
			},
			{
				"data": "actionType",
				"className": "c-table__cell",
				"searchable": true,
			},
			{
				"data": "newName",
				"className": "c-table__cell",
				"searchable": true,
			},
			{
				"data": "effectiveDate",
				"className": "c-table__cell",
				"searchable": true,
			},
		];

		CGS.table(tableElement, {
			ajax: {
				url: apiEndpoint,
				dataSrc: function (json) {
					return json.data.issuerList;
				},
			},
			columns: columns,
			columnDefs: [],
			paging: false,
			scrollY: "auto",
			dom: "<'_df _mbsm _ttu'<'_fxg'<'_fz12'<'_di issuerLink'>><'_fz16 issuerTitle'>><'c-table__export _p0'B>><'_h100p _df _fxdc _bd1gray20' rt>",
			initComplete: function (settings, json) {
				var tableWrapper = settings.nTableWrapper;
				var scrollBody = settings.nScrollBody;
				var issuerLink = "Issuer Link: " + json.data.issuerLink;
				var issuerName = json.data.issuerName;

				scrollBody.style.flexGrow = "0";
				tableWrapper.querySelector(".issuerLink").innerHTML = issuerLink;
				tableWrapper.querySelector(".issuerTitle").innerHTML = issuerName;
			},
		});
	};

	Plugins.AssociatedIssuer = AssociatedIssuer;
})(Sushi || (Sushi = {}), Sushi.Plugins || (Sushi.Plugins = {}), CGS || (CGS = {}));
